import { Building2, FileText, Landmark, Receipt, Users, Wallet } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

/** Accounts desk — monthly close, contracts, finance ledger, invoicing. */
export function buildAccountsDeskGroup(ctx: StaffNavContext): StaffNavGroup | null {
  if (
    !ctx.showAccountsWorkspace &&
    !ctx.showAccountsContracts &&
    !ctx.showFinanceNav &&
    !ctx.showInvoicingNav
  ) {
    return null
  }

  const children: StaffNavNode[] = []

  if (ctx.showAccountsWorkspace) {
    children.push(
      leaf(
        'accounts_monthly_close',
        'Monthly close',
        AppPaths.payrollAccounts,
        Wallet,
        ['accounts', 'consolidate', 'payrun', 'close'],
      ),
      leaf(
        'accounts_people',
        'People',
        AppPaths.payrollAccountsPeople,
        Users,
        ['accounts', 'salary', 'billing', 'ready'],
        { activeWhenPrefix: true },
      ),
      leaf(
        'accounts_clients',
        'Clients',
        AppPaths.payrollAccountsClients,
        Building2,
        ['accounts', 'rate card', 'commercial'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showAccountsContracts) {
    children.push(
      leaf(
        'accounts_contracts',
        'Contracts',
        AppPaths.accountsContracts,
        FileText,
        ['accounts', 'commercial', 'contracts', 'expiry'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showFinanceNav) {
    children.push(
      leaf(
        'accounts_finance_overview',
        'Finance ledger',
        AppPaths.financeOverview,
        Landmark,
        ['finance', 'petty', 'pemo', 'ledger'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showInvoicingNav) {
    children.push(
      leaf(
        'accounts_invoicing',
        'Invoicing',
        AppPaths.invoicing,
        Receipt,
        ['invoice', 'billing', 'collections', 'ar', 'follow up', 'pending'],
        { activeWhenPrefix: true },
      ),
    )
  }

  return group('accounts', 'Accounts', Receipt, ['accounts', 'finance', 'payroll'], children)
}
